import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Helmet } from "react-helmet";

// 📄 Pages
import Biographie from "./pages/Biographie.js";
import MachinesPage from "./pages/MachinesPage.js";
import MachinesDetailPage from "./pages/MachinesDetailPage.js";
import Maquettes from "./pages/Maquettes.js";
import Figurines from "./pages/Figurines.js";
import Exposition from "./pages/Exposition.js";
import Contact from "./pages/Contact.js";

// 🧩 Composants
import MaquetteTemplate from "./components/MaquetteTemplate.js";
import ArchiveTemplate from "./components/ArchiveTemplate.js";
import Nav from "./components/Nav.js"; // ✅ Nouveau Nav

export default function App() {
  return (
    <Router>
      {/* 🧠 Métadonnées SEO */}
      <Helmet>
        <title>Séraphin Clerc – Inventeur fictif du XIXe siècle</title>
        <meta
          name="description"
          content="Site dédié à Séraphin Clerc, inventeur fictif du XIXe siècle. Découvrez ses machines, maquettes, archives et expositions dans un univers steampunk et rétrofuturiste."
        />
        <meta
          name="keywords"
          content="Séraphin Clerc, inventeur fictif, XIXe siècle, steampunk, stempunkart, rétrofuturisme, machines fantastiques, vaporistes, Jules Verne, Dominique Formaz"
        />
        <meta
          name="google-site-verification"
          content="google231946896bc49534.html"
        />
      </Helmet>

      {/* ☰ Barre de navigation */}
      <Nav />

      {/* 🔀 Navigation */}
      <Routes>
        <Route path="/" element={<Biographie />} />
        <Route path="/machines" element={<MachinesPage />} />
        <Route path="/machines/:id" element={<MachinesDetailPage />} />
        <Route path="/machines/:id/maquette" element={<MaquetteTemplate />} />
        <Route path="/machines/:id/archives" element={<ArchiveTemplate />} />
        <Route path="/maquettes" element={<Maquettes />} />
        <Route path="/figurines" element={<Figurines />} />
        <Route path="/exposition" element={<Exposition />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
    </Router>
  );
}